import { Context, LoadPaymentDetailsListParams } from '../../../types';
import { PaymentDetails } from '@vsf-enterprise/sap-commerce-webservices-sdk';
import { GetPaymentDetailsListProps } from '@vsf-enterprise/sapcc-api';
import { createBasePropsFromCustomQuery } from '../../../helpers/createBasePropsFromCustomQuery';
import { ANONYMOUS_USER_ID, getActiveUserId } from '../../../helpers';

export async function loadPaymentDetailsList(
  context: Context,
  params: LoadPaymentDetailsListParams
): Promise<PaymentDetails[]> {
  const {
    $sapcc: {
      config: { $cookies }
    }
  } = context;

  const userId = getActiveUserId($cookies);
  if (userId === ANONYMOUS_USER_ID) return [];

  const props: GetPaymentDetailsListProps = {
    saved: params.saved,
    ...createBasePropsFromCustomQuery(params.customQuery)
  };
  const { payments } = await context.$sapcc.api.getPaymentDetailsList(props);
  return payments;
}
